module.exports = "<div class=\"program-list-container\">\r\n  <div class=\"program-container\">\r\n    <app-programs *ngFor=\"let program of programs | orderByField:'name'\" [program]=\"program\"></app-programs>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/program-list/program-list.component.html
// module id = ../../../../../src/app/loanprograms/program-list/program-list.component.html
// module chunks = main